import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { extendedTestimonials } from '../data/testimonials';
export function ExtendedTestimonials() {
  return <section className="py-24 px-4 bg-cream border-y border-mist" data-id="element-42" data-mp="bjmfuaxnuwpf">
      <div className="max-w-6xl mx-auto" data-id="element-43" data-mp="bibc2b47toyb">
        <div className="text-center mb-16" data-id="element-44" data-mp="gb4lhcamplgq">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-brand" data-id="element-45" data-mp="gcxsisp5m7p9">
            What Golf Instructors Who Already Have Their System Are Saying
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-46" data-mp="q7hdm5qizr9d">
          {extendedTestimonials.map((testimonial, index) => <motion.article key={testimonial.name} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-ivory border border-mist p-8 rounded-2xl relative flex flex-col ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-47" data-mp="z9qjujergygy" data-mpi={index}>
              <Quote className="absolute top-6 right-6 text-sand" size={48} aria-hidden="true" data-id="element-48" data-mp="37zd147tzdyoo" />
              <div className="flex gap-1 text-gold mb-6" aria-label="5 out of 5 stars" data-id="element-49" data-mp="33zvv9dan6ziz">
                {[...Array(5)].map((_, starIndex) => <Star key={starIndex} size={16} fill="currentColor" aria-hidden="true" data-id="element-50" data-mp="2yxwri2azq0li" data-mpi={starIndex} />)}
              </div>
              <p className="text-ink/80 italic mb-8 relative z-10 leading-relaxed" data-id="element-51" data-mp="3rnvm0d7yepxk">“{testimonial.text}”</p>
              <div className="flex items-center gap-4 mt-auto" data-id="element-52" data-mp="3mosorey7to05">
                <div className="w-12 h-12 rounded-full bg-brand border border-gold flex items-center justify-center text-gold font-bold text-lg" data-id="element-53" data-mp="3mr58nxnja8fu">
                  {testimonial.initials}
                </div>
                <div data-id="element-54" data-mp="26b2bbhl7hndu">
                  <div className="font-bold text-brand" data-id="element-55" data-mp="26aj00jq29x8s">{testimonial.name}</div>
                  <div className="text-xs text-olive" data-id="element-56" data-mp="27s7wzffgui5h">{testimonial.role}</div>
                </div>
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}